import { Outlet } from "react-router-dom"

import { Box, Alert } from "@mui/material"

import { LEVEL } from "@app/services/env"
import { Sidebar } from "@app/components/sidebar/Sidebar"

export const Layout: React.FC = () => {
	return (
		<Box sx={{ display: "flex", height: "100vh", minHeight: 0 }}>
			<Sidebar />
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					minWidth: 0,
					p: 1,
					display: "flex",
					flexDirection: "column",
					minHeight: 0,
				}}
			>
				{LEVEL === "stage" && <Alert severity="warning">You are currently in a testing environment!</Alert>}
				<Outlet />
			</Box>
		</Box>
	)
}
